import { Fragment } from "react";
import { motion } from "framer-motion";
import { Plane, HeartHandshake } from "lucide-react";
import ChapterHeading from "./ChapterHeading";
import HeartPhotos from "./HeartPhotos";

const people = [
  {
    icon: Plane,
    tag: "Lui · Altitudine 43.000 ft",
    name: "Alessandro",
    text: "Ai comandi di un aereo tra i cieli di tutto il mondo, pensava che la sua avventura più grande fosse sempre a migliaia di chilometri di distanza. Invece ha trovato l'amore della sua vita proprio dietro casa.",
  },
  {
    icon: HeartHandshake,
    tag: "Lei · Equilibrio & Movimento",
    name: "Federica",
    text: "Attraverso la fisioterapia ha imparato a prendersi cura del prossimo ma è il suo cuore a portarla sempre alla ricerca di nuove emozioni. Il destino le ha riservato l'incontro proprio con l'unico uomo capace di farle battere forte il cuore.",
  },
];

export default function Story() {
  return (
    <section id="storia" className="px-6 sm:px-12 lg:px-24 py-20 sm:py-28" data-testid="story-section">
      <div className="mx-auto max-w-7xl">
        <ChapterHeading
          number="01"
          title="La Nostra Rotta"
          kicker="Dalle alte quote dei voli di Alessandro alla sensibilità terapeutica di Federica: due mondi apparentemente lontani ma uniti dal desiderio di esplorare la vita insieme."
          testid="story-heading"
        />

        <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
          <div className="hidden sm:block absolute left-1/2 top-[36%] -translate-x-1/2 -translate-y-1/2 z-20">
            <HeartPhotos />
          </div>
          {people.map((p, i) => (
            <Fragment key={p.name}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
                whileHover={{ y: -6 }}
                className={`rounded-2xl border border-sand bg-cream p-8 sm:p-12 flex flex-col ${i === 0 ? "pb-44 sm:pb-12 sm:pr-44 lg:pr-48" : "pt-44 sm:pt-12 sm:pl-44 lg:pl-48"}`}
                data-testid={`story-card-${p.name.toLowerCase()}`}
              >
                <div className="w-12 h-12 rounded-full bg-panna border border-sand flex items-center justify-center mb-6">
                  <p.icon className="w-5 h-5 text-terracotta" />
                </div>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-clay mb-3">
                  {p.tag}
                </span>
                <h3 className="font-serif text-2xl sm:text-3xl text-[#2D2A26] mb-4">{p.name}</h3>
                <p className="text-sm sm:text-base leading-relaxed text-[#5C564E]">{p.text}</p>
              </motion.div>
              {i === 0 && (
                <div className="relative sm:hidden h-0 z-20" aria-hidden="true">
                  <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2">
                    <HeartPhotos />
                  </div>
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
